import * as actionTypes from '../actions/actionTypes';

const initialState = {
    total: 0,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.COUNT_RESELLERS_LOADING:
            return {
                ...state,
                loading: true,
                total: 0,
                error: null
            };
        case actionTypes.COUNT_RESELLERS_FAIL:
            return {
                ...state,
                loading: false,
                total: 0,
                error: action.error
            };
        case actionTypes.COUNT_RESELLERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                total: action.payload.data
            };
        default:
            return state;
    }
};

export default reducer;